import 'magnific-popup';
import moment from 'moment';

jQuery( document ).ready(function($) {
    $('.clue-input').on('wheel', function(e) {
        e.preventDefault();
    });
    $('.clue-input').not('.clue-input-char').on('input', function() {
      let value = $(this).val();
      value = value.replace(/\D/g, '');

      if (value.length > 2) {
        $(this).val(value.substring(0, 2));
      }
    });
    // Final clue inputs: a single letter or digit, letters shown uppercase.
    $('.clue-input-char').on('input', function() {
      $(this).val($(this).val().replace(/[^a-z0-9]/gi, '').slice(-1).toUpperCase());
    });

    $('.cipher-form').on('submit', function(e) {
      e.preventDefault();
      var form = jQuery(this);
      var data = form.serialize();
      data += '&action=check_cipher';
      console.log('data-submitted');
      $.ajax({
        url: ajax_object.ajaxurl,
        type: 'POST',
        data: data,
        dataType: 'json',
        success: function(response) {
          console.log(response.data.message);

          if (response.data.message == "NoUser"){
            $.magnificPopup.open({
              items: {
                src: '#nouser',
                type: 'inline'
              }
            });
          } else if (response.data.guesses > 2){
            $.magnificPopup.open({
                  items: {
                    src: '#limited',
                    type: 'inline'
                  }
                });
          } else {
            if (response.data.message == "Correct"){
              $.magnificPopup.open({
                items: {
                  src: '#correct',
                  type: 'inline'
                }
              });
            } else if (response.data.message == "Incorrect"){
              if (response.data.guesses == 1){
                $.magnificPopup.open({
                  items: {
                    src: '#incorrect',
                    type: 'inline'
                  }
                });
              } else  if (response.data.guesses == 2){
                $.magnificPopup.open({
                  items: {
                    src: '#incorrect-notry',
                    type: 'inline'
                  }
                });
              }
            } else {
              $.magnificPopup.open({
                items: {
                  src: '#error',
                  type: 'inline'
                }
              });
            }
          }
        }
      });
    });

    $('.menu-toggle').on('click', function(e){
      e.preventDefault();
      $('.menu-wrap').toggleClass('active');
      $('.right').toggleClass('active');
    })

    $('.clue-links .progress-locked').on('click', function(e){
      e.preventDefault();
      $.magnificPopup.open({
        items: {
          src: '#progressgate',
          type: 'inline'
        }
      });
    })
    $('.clue-links .time-locked').on('click', function(e){
      e.preventDefault();
      $.magnificPopup.open({
        items: {
          src: '#timegate',
          type: 'inline'
        }
      });
    })
    $('.key-link.disabled-link a').on('click', function(e){
      e.preventDefault();
      $.magnificPopup.open({
        items: {
          src: '#finalgate',
          type: 'inline'
        }
      });
    })
    $('.final-locked').on('click', function(e){
      e.preventDefault();
      $.magnificPopup.open({
        items: {
          src: '#finalgate', 
          type: 'inline'
        }
      });
    })

    var countDownDate = moment($('#eventdate').html());
    // Update the count down every 1 second
    var x = setInterval(function() {

        var now = moment();
        var distance = countDownDate.diff(now);
 
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        $(".r-days").html(days);
        $(".r-hours").html(hours);
        $(".r-minutes").html(minutes);
        $(".r-seconds").html(seconds);

        if (distance < 0) {
            clearInterval(x);
            $(".countdown").hide(); 
        }
    }, 1000);

    // iOS Detection
    function isIOS() {
      let platform = navigator?.userAgentData?.platform || navigator?.platform;
      return ([
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(platform)) ||
      (platform == "MacIntel" && navigator.maxTouchPoints > 1) 
    }

    if (isIOS()) {
      $("body").addClass("ios")
    }
});